/** Tolerant parser for Foroba GET /auth/sessions (returns {sessions: [...]}). */
export interface DeviceSession {
  id: number
  device_label: string
  created_at: string
  last_used_at?: string | null
  current?: boolean
}

function isSession(x: unknown): x is DeviceSession {
  if (typeof x !== 'object' || x === null) return false
  const r = x as Record<string, unknown>
  return typeof r.id === 'number' && typeof r.device_label === 'string' && typeof r.created_at === 'string'
}

export function normalizeSessions(body: unknown): DeviceSession[] {
  const list = Array.isArray(body)
    ? body
    : typeof body === 'object' && body !== null && Array.isArray((body as { sessions?: unknown }).sessions)
      ? (body as { sessions: unknown[] }).sessions
      : []
  return list.filter(isSession)
}
